import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseIcon } from 'assets/icons/ico_close.svg';
import { ReactComponent as InfoIcon } from 'assets/icons/ico_info_circle_blue.svg';

import Paging from 'components/common/paging';
import ButtonText from 'components/common/buttonText';
import CheckBox from 'components/common/checkbox/checkbox';
import ToggleText from 'components/common/toggleText';

const CommunitiesModal = ({ display, setDisplay, selectedCommunities, setSelectedCommunities, communities, children }) => {

    const { t } = useTranslation();
    const handleOverlayOnClick = (e) => {
        closeModal();
        e.stopPropagation();
    };

    const closeModal = () => {
        document.body.classList.remove('overflow-hidden');
        setDisplay(false);
    };

    const itemsPerPage = 8;
    const [localCommunities, setlocalCommunities] = useState(communities);
    const [filteredlocalCommunities, setFilteredlocalCommunities] = useState(communities || []);
    const [isAllChecked, setIsAllChecked] = useState(true);
    const [showSelectedOnly, setShowSelectedOnly] = useState(false);
    const [communityPages, setCommunityPages] = useState();
    const [currentCommunityPage, setcurrentCommunityPage] = useState(0);


    useEffect(() => {
        if (selectedCommunities && communities) {
            const selectedIds = new Set(
                (selectedCommunities || []).map((c) =>
                    typeof c === 'object' ? c.communityExtId : c
                )
            );

            const communitiesWithCheckedStatus = communities.map((community) => {
                const isSelected = selectedIds.has(community.communityExtId);
                return { ...community, isChecked: !!isSelected };
            });

            setlocalCommunities(communitiesWithCheckedStatus);
        }
    }, [selectedCommunities, communities]);

    useEffect(() => {
        if (!filteredlocalCommunities) return;
        const selectedIds = new Set(
            (selectedCommunities || []).map((c) => (typeof c === 'object' ? c.communityExtId : c))
        );

        const filteredIds = new Set(filteredlocalCommunities.map(c => c.communityExtId));
        const allFilteredSelected = Array.from(filteredIds).every(id => selectedIds.has(id));

        if (allFilteredSelected) {
            setIsAllChecked(true);
        } else {
            setIsAllChecked(false);
        }
    }, [selectedCommunities, filteredlocalCommunities]);

    useEffect(() => {
        if (filteredlocalCommunities) {
            setCommunityPages(Math.ceil(filteredlocalCommunities?.length / itemsPerPage));
        }
    }, [filteredlocalCommunities]);

    useEffect(() => {
        if (display) {
            document.body.classList.add('overflow-hidden');
        } else {
            document.body.classList.remove('overflow-hidden');
        }
    }, [display]);

    useEffect(() => {
        if (showSelectedOnly) {
            const selectedCommunities = localCommunities.filter((community) => community.isChecked);
            setFilteredlocalCommunities(selectedCommunities);
        } else {
            setFilteredlocalCommunities(localCommunities);
        }
    }, [showSelectedOnly, localCommunities]);

    const handleCommunityItemSelect = (community) => {
        const id = community.communityExtId;
        const selectedIds = new Set(
            (selectedCommunities || []).map((c) => (typeof c === 'object' ? c.communityExtId : c))
        );

        if (community.isChecked) {
            /* It was checked previously, remove */
            selectedIds.delete(id);
        } else {
            /* Else add */
            selectedIds.add(id);
        }

        setSelectedCommunities(Array.from(selectedIds));
        setlocalCommunities((prev) =>
            (prev || []).map((c) =>
                c.communityExtId === id ? { ...c, isChecked: !community.isChecked } : c
            )
        );
    };

    const handleSelectAllParkingSpots = () => {
        const allIds = (localCommunities || []).map(c => c.communityExtId);
        if ((selectedCommunities || []).length === allIds.length) {
            setSelectedCommunities([]);
            setlocalCommunities((prev) => (prev || []).map(c => ({ ...c, isChecked: false })));
        } else {
            setSelectedCommunities(allIds);
            setlocalCommunities((prev) => (prev || []).map(c => ({ ...c, isChecked: true })));
        }
    };

    if (!display) {
        return (null);
    }

    return (
        <>
            {/* Overlay */}
            <div className="fixed inset-0 z-50 bg-black bg-opacity-60">
            </div>
            {/* Modal */}
            <div onClick={(e) => handleOverlayOnClick(e)} className="fixed inset-0 z-50 overflow-y-scroll overflow-x-hidden px-6">
                <div onClick={(e) => e.stopPropagation()} className="flex mr-auto ml-auto mt-6 mb-6 flex-col max-w-[1140px] p-6 w-full justify-center rounded-xl overflow-y-hidden items-center bg-white">
                    <div className="flex w-full justify-end mb-6">
                        <button className="h-4" onClick={() => { closeModal(); }}>
                            <CloseIcon className="h-5 w-5" />
                        </button>
                    </div>
                    <div className="flex flex-col rounded-xl shadow p-6 w-full">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-xl font-medium">{t('selectCommunitiesModal.selectCommunities')}</h2>
                            {/* <ButtonToggle defaultIcon={<CloseIcon />} toggledIcon={<CloseIcon />} isToggled={false} title={t('createParkingArea.chargingPost')} onClick={() => { }} /> */}

                            <div className="w-[180px]">

                                <ToggleText
                                    defaultText={t('generic.all')}
                                    toggledText={t('generic.selected')}
                                    isToggled={showSelectedOnly} onClick={() => {
                                        setShowSelectedOnly(!showSelectedOnly);
                                    }} />
                            </div>
                        </div>
                        <div className="-mr-6 -ml-6 airpark-scroll overflow-x-scroll">
                            <table className="table-auto w-full">
                                <thead>
                                    <tr className="text-left h-11 bg-airpark-gray-300">
                                        <th className="pl-6">
                                            <CheckBox isChecked={isAllChecked} onClick={() => {
                                                handleSelectAllParkingSpots();
                                            }} />
                                        </th>
                                        <th className="pl-6">{t('selectCommunitiesModal.id')}</th>
                                        <th className="pl-6">{t('selectCommunitiesModal.name')}</th>
                                        <th className="pl-6">{t('selectCommunitiesModal.numberOfMembers')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredlocalCommunities && filteredlocalCommunities?.length > 0 && filteredlocalCommunities.slice(currentCommunityPage * itemsPerPage, ((currentCommunityPage * itemsPerPage) + itemsPerPage)).map((community, i) => {
                                        return (
                                            <tr key={i} className="h-16 border-b-[1px] last:border-b-[0px]">
                                                <td className="pl-6">
                                                    <CheckBox isChecked={community.isChecked ?? false} onClick={() => {
                                                        if (!community.isDisabled) {
                                                            handleCommunityItemSelect(community);
                                                        }
                                                    }} />
                                                </td>
                                                <td className="pl-6">{community.communityExtId}</td>
                                                <td className="pl-6">{community.name}</td>
                                                <td className="pl-6">{community.numberOfMembers}</td>
                                            </tr>
                                        );
                                    })
                                    }
                                    {communities && communities.length < 1 &&
                                        <tr className="h-16">
                                            <td className="text-center" colSpan={5}>
                                                <div className="flex pl-6 gap-3 flex-row items-center justify-left">
                                                    <InfoIcon className="h-6 w-6" />
                                                    <span>{t('selectCommunitiesModal.noCommunitiesAvailable')}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <Paging totalNumberOfPages={communityPages} currentPage={currentCommunityPage} setCurrentPage={setcurrentCommunityPage} />
                    </div>


                    <div className="flex flex-col w-full items-start justify-between mt-3">
                        <div className="flex">
                            {t('selectCommunitiesModal.noCommunitiesAvailable', { number: selectedCommunities?.length })}
                        </div>
                        {children}

                    </div>
                    <div className="flex  w-full justify-end flex-1 mt-3">
                        <ButtonText onClick={() => { closeModal(); }} className="w-80">
                            {t('generic.ok')}
                        </ButtonText>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CommunitiesModal;